"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=SuperAdminPermissionsTypes.js.map